import { ApiRoutes } from '../constants/routes';

// When curating for a label (label listening mode, as a team member),
// playlists are created under and listed for that label.

export const curationLabelFields = (curatingLabel) => (curatingLabel ? { label_id: curatingLabel.id } : {});

export const userPlaylistsUrl = (curatingLabel) => (
  curatingLabel ? `${ApiRoutes.UserPlaylists}?label_id=${curatingLabel.id}` : ApiRoutes.UserPlaylists
);
